import styled from 'styled-components';

import { FlexDiv } from 'commonStyles';

export const TagItem = styled.li`
	padding: 8px;
	margin-bottom: 16px !important;
	margin-right: 8px;
	background-color: #F2F2F2;
	border-radius: 4px;
	border: 1px solid #D8D8D8;
	font-size: 14px;
	line-height: 20px;
	color: #000000;
`;

export const TagsWrapper = styled(FlexDiv)`
	max-height: 250px;
	overflow-y : scroll;
`;
